import { Dropdown, Button } from '@bigcommerce/big-design'
import { LanguageIcon } from '@bigcommerce/big-design-icons'

import { useChangeIl8n } from '@/hooks'
import { useAppSelector, useAppDispatch, setLanguage } from '@/store'

export const Language = () => {
  const { changeLanguage } = useChangeIl8n()
  const { language } = useAppSelector((state) => state.global)
  const dispatch = useAppDispatch()

  const change = (lang: string) => {
    dispatch(setLanguage(lang))
    changeLanguage(lang)
  }

  const langItems = [
    {
      content: 'English',
      onItemClick: () => change('en'),
      hash: 'en',
    },
    {
      content: 'español',
      onItemClick: () => change('es'),
      hash: 'es',
    },
    {
      content: 'Français',
      onItemClick: () => change('fr'),
      hash: 'fr',
    },
  ]

  return (
    <Dropdown
      items={langItems}
      placement="bottom-end"
      toggle={
        <Button iconLeft={<LanguageIcon size={16} />} variant="subtle">
          {langItems.find((item) => item.hash === language)?.content || ''}
        </Button>
      }
    />
  )
}
